import React from 'react';
import MuiFormGroup, { FormGroupProps } from '@mui/material/FormGroup';
import { formGroupSx } from './FormGroup.styles';
import { SxProps, Theme } from '@mui/material/styles';

export const FormGroup = React.forwardRef<HTMLDivElement, FormGroupProps>((props, ref) => {
  return <MuiFormGroup ref={ref} {...props} sx={[formGroupSx, props.sx] as SxProps<Theme>} />;
});

FormGroup.displayName = 'FormGroup';